import React from 'react';

import { ConfirmationModal } from './confirmation_modal.jsx';

export const Button = ({text, onButtonClick, disabled, iconStyle, id = "continueButton"}) => {
  return(
    <button
      className={"standard-btn large light-blue" + (disabled ? " disabled" : "")}
      id={id}
      disabled={disabled}
      onClick={(event) => onButtonClick(event) }
    >
      {iconStyle && <div className="icon" style={iconStyle}></div> }
      {text}
    </button>
  );
};

export const CustomButton = ({text, onButtonClick, disabled, customClasses, id}) => {
  return(
    <div className="custom-button">
      <button
        className={(disabled ? "disabled" : "") + (customClasses ? ` ${customClasses}` : "")}
        disabled={disabled}
        id={id ? id : ""}
        onClick={(event) => onButtonClick(event) }
      >
        {text}
      </button>
    </div>
  );
};

export const ContinueButton = ({text, onButtonClick, disabled}) => {
  return(
    <button
      className={"standard-btn green" + (disabled ? " disabled" : "")}
      id={"continueButton"}
      disabled={disabled}
      onClick={(event) => onButtonClick(event) }
    >
      {text}
      <div className="icon forward-icon"/>
    </button>
  );
};

 export const BackButton = ({text, onButtonClick, disabled}) => {
  return(
    <button
      className={"standard-btn blue" + (disabled ? " disabled" : "")}
      id={"backButton"}
      disabled={disabled}
      onClick={ (event) => onButtonClick() }
    >
      <div className="icon back-icon"/>
      {text}
    </button>
  );
};

export const LogoutButton = ({text, onButtonClick, disabled}) => {
  return(
    <button
      className={"standard-btn blue" + (disabled ? " disabled" : "")}
      id={"logoutButton"}
      disabled={disabled}
      onClick={(event) => onButtonClick(event) }
    >
      {text}
      <div className="icon logout-icon"/>
    </button>
  );
};

export const SkipButton = ({text, onClick}) => {
  return(
    <div className="skipButton">
      <button
        className={"dropbtn " + (this.state.menuOpen ? "menu-open" : "") }
        id={"skipButton"}
        disabled={disabled}
        onClick={(event) => this.toggleOpen()}
      >
        {text}

      </button>
      <ConfirmationModal
            title={this.props.title}
            items={this.props.options}
            onItemSelected={() => {}}
            onClose={() => this.toggleOpen()}
            visible={this.state.menuOpen}
          />
    </div>
  );
};
